module.exports = __webpack_public_path__ + "static/image/history/m/202010@3x.jpg?ef0d1b3c";